// extracted by mini-css-extract-plugin
module.exports = {"detailsList":"StatOnWord_detailsList__3XRPW","empty":"StatOnWord_empty__2gQaN"};